'use strict';

productOverview.$inject = ["Enums", "gettextCatalog", "sortProperties", "Paging", "$state"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productOverview = productOverview;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productOverview(Enums, gettextCatalog, sortProperties, Paging, $state) {
    var clazz = function ProductOverview() {
        var defaults = {
            products: [],
            filter: null,
            filters: [],
            paging: null,
            sorting: null,
            productsAvailableForContext: false,
            productsAvailableForCriteria: true,
            isLoadingInitial: false,
            isLoading: false,
            errorOccurred: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (context) {
        var productOverview = new clazz();
        productOverview.products = [];
        productOverview.filter = null;
        productOverview.filters = [];
        productOverview.paging = Paging.create({ totalItems: 0, itemsPerPage: parseInt(window.sessionStorage.getItem('pageSize'), 10) || 24, page: 1, pageCount: 1, pageNumbers: [] });
        productOverview.sorting = getSortingByContext(context);
        return productOverview;

        function getSortingByContext(context) {

            if (context === Enums.searchContext.discount.id || context === Enums.searchContext.seller.id) {
                return {
                    enableSorting: true,
                    sortProperty: window.localStorage.getItem($state.current.name + '-sortProperty') || 'DiscountDate',
                    sortAsc: window.localStorage.getItem($state.current.name + '-sortAsc') || false,
                    properties: [sortProperties['DiscountDate'], sortProperties['Name'], sortProperties['UnitPrice']]
                };
            } else {
                return {
                    enableSorting: true,
                    sortProperty: window.localStorage.getItem($state.current.name + '-sortProperty') || 'Name',
                    sortAsc: window.localStorage.getItem($state.current.name + '-sortAsc') || true,
                    properties: [sortProperties['Name'], sortProperties['UnitPrice']]
                };
            }
        }
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/productOverviewModel.js
// module id = 777
// module chunks = 0